export default __webpack_public_path__ + "static/media/featured-shape.e6d5bdae.png";